export default "__VITE_ASSET__DfisGAGF__"